import React from 'react';
import PropTypes from 'prop-types';
import View from "react-native-web/dist/exports/View";
import { useCarousel } from './CarouselContext';
import CarouselThumbnail from './CarouselThumbnail';
import { StackWrap } from '../StackView';
import { useThemeTokens } from '../ThemeProvider';
import { useViewport } from '../ViewportProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const CarouselThumbnailNavigation = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    thumbnails = []
  } = _ref;
  const viewport = useViewport();
  const {
    alignItems
  } = useThemeTokens('CarouselThumbnail', {}, {
    viewport
  });
  const {
    totalItems
  } = useCarousel();
  if (thumbnails.length !== totalItems) {
    throw new Error('Thumbnail set provided does not match the number of slides in the carousel');
  }
  const {
    containerPaddingTop: thumbnailContainerPaddingTop
  } = useThemeTokens('CarouselThumbnail');
  const stackWrapTokens = {
    justifyContent: 'flex-start'
  };
  const containerStyles = {
    justifyContent: 'center',
    alignItems,
    paddingTop: thumbnailContainerPaddingTop
  };
  return /*#__PURE__*/_jsx(View, {
    style: containerStyles,
    children: /*#__PURE__*/_jsx(StackWrap, {
      direction: "row",
      tokens: stackWrapTokens,
      space: 2,
      ref: ref,
      children: thumbnails.map((_ref2, index) => {
        let {
          accessibilityLabel,
          alt,
          src
        } = _ref2;
        return /*#__PURE__*/_jsx(CarouselThumbnail, {
          accessibilityLabel: accessibilityLabel,
          alt: alt,
          index: index,
          src: src
        }, src);
      })
    })
  });
});
CarouselThumbnailNavigation.displayName = 'CarouselThumbnailNavigation';
CarouselThumbnailNavigation.propTypes = {
  /**
   * An array of objects containing information on the thumbnail images.
   */
  thumbnails: PropTypes.arrayOf(PropTypes.shape({
    accessibilityLabel: PropTypes.string,
    alt: PropTypes.string,
    src: PropTypes.string
  })).isRequired
};
export default CarouselThumbnailNavigation;